import React from 'react';
import PropTypes from 'prop-types';
import PageHeadingWrapper from 'components/PageHeadingWrapper';
import YourPackageDetailsWidget from 'components/YourPackageDetailsWidget';
import OrderTopupWidget from 'components/widgets/OrderTopupWidget';
import SkipPackWidget from 'components/widgets/SkipPackWidget';
import ViewLayout from 'views/ViewLayout';

const PackageView = ({
  pack, memberSince, subscriptionExpiry, changeUsageDisableReason,
  skippablePackId, canTopUp, nextPaymentAmount, hideChangeUsage,
}) => (
  <ViewLayout className="PackageView">
    <PageHeadingWrapper>
      <h1>Package details</h1>
      <p>A breakdown of your regular deliveries, plus all the great benefits of easycare</p>
    </PageHeadingWrapper>
    <YourPackageDetailsWidget
      pack={pack}
      memberSince={memberSince}
      subscriptionExpiry={subscriptionExpiry}
      changeUsageDisableReason={changeUsageDisableReason}
      nextPaymentAmount={nextPaymentAmount}
      hideChangeUsage={hideChangeUsage}
    />
    { canTopUp && <OrderTopupWidget /> }
    { skippablePackId && <SkipPackWidget packId={skippablePackId} /> }
  </ViewLayout>
);

PackageView.displayName = 'PackageView';

PackageView.propTypes = {
  pack: PropTypes.shape({}).isRequired,
  memberSince: PropTypes.string.isRequired,
  subscriptionExpiry: PropTypes.string.isRequired,
  changeUsageDisableReason: PropTypes.node,
  skippablePackId: PropTypes.string,
  nextPaymentAmount: PropTypes.number,
  canTopUp: PropTypes.bool,
  hideChangeUsage: PropTypes.bool,
};

PackageView.defaultProps = {
  skippablePackId: null,
  changeUsageDisableReason: null,
  canTopUp: false,
  nextPaymentAmount: null,
  hideChangeUsage: false,
};

export default PackageView;
